import { FormField } from '@/components/custom/erp';

interface Props {
  formMode: 'add' | 'edit' | 'view';
}

export const BasicInformationTab = ({ formMode }: Props) => (
  <div className='p-4'>
    <div className='grid gap-x-4 gap-y-4 lg:grid-cols-1'>
      <div className='grid grid-cols-1 items-center gap-4 lg:grid-cols-4'>
        <div className='lg:col-span-2'>
          <FormField
            label='Mã vật tư'
            className='flex items-center gap-x-1'
            labelClassName='min-w-32 font-medium'
            name='ma_vt'
            type='text'
            disabled={formMode === 'view' || formMode === 'edit'}
          />
        </div>
        <div className='flex flex-wrap items-center justify-start gap-x-6 lg:col-span-2 lg:pl-4'>
          <FormField
            label='Theo dõi tồn kho'
            className='flex items-center gap-x-2'
            labelClassName='font-medium'
            name='ton_kho_yn'
            type='checkbox'
            disabled={formMode === 'view'}
          />
          <FormField
            label='Theo dõi lô'
            className='flex items-center gap-x-2'
            labelClassName='font-medium'
            name='lo_yn'
            type='checkbox'
            disabled={formMode === 'view'}
          />
          <FormField
            label='Theo dõi quy cách'
            className='flex items-center gap-x-2'
            labelClassName='font-medium'
            name='qc_yn'
            type='checkbox'
            disabled={formMode === 'view'}
          />
        </div>
      </div>
      <FormField
        label='Tên vật tư'
        className='flex items-center gap-x-1'
        labelClassName='min-w-32 font-medium'
        name='ten_vt'
        type='text'
        disabled={formMode === 'view'}
      />
      <FormField
        label='Tên khác'
        className='flex items-center gap-x-1'
        labelClassName='min-w-32 font-medium'
        name='ten_vt2'
        type='text'
        disabled={formMode === 'view'}
      />
    </div>
  </div>
);
